import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import CheckCircleIcon from '@mui/icons-material/CheckCircleTwoTone';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceContainerAvailabilityDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Avail',
	minWidth: 75,
	width: 75,
	headerName: 'Trc Avail',
	renderHeader: () => <RenderHeader primaryText='Trc Avail' />,
	renderCell: ({ row }) => (
		<>
			{typeof row.traceCntrAvail === 'boolean' && row.traceCntrAvail && (
				<div className={styles['center-content']}>
					<CheckCircleIcon color='success' />
				</div>
			)}
			{typeof row.traceCntrAvail === 'string' && <RenderCell primarySlot={<span title={row.traceCntrAvail}>{row.traceCntrAvail}</span>} />}
		</>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcCntrAvail } = row;
				return caseInsensitiveIncludes(value, [trcCntrAvail]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcCntrAvail ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceContainerAvailabilityDefinition;
